'use client';

import React from 'react';
import { Star, CheckCircle, Quote, Building2, Home } from 'lucide-react';

export function CustomerReviews() {
  const reviews = [
    {
      author: 'Arben Hoxha',
      location: 'Vilë Rezidenciale, Lundër — Tiranë',
      system: 'Pompë Nxehtësie Daikin 14kW + Ngrohje Dyshemeje',
      comment:
        'Ekipi i DYRMA Climate bëri një punë shembullore. Nga llogaritja e tubacioneve deri te vakumimi i linjave dhe vënia në punë e pompës. Fatura e energjisë këtë dimër zbriti me më shumë se 50%.',
      rating: 5,
      type: 'Vilë Private',
    },
    {
      author: 'Eleni Gjika (Menaxhere Operative)',
      location: 'Hotel Panorama, Durrës',
      system: 'Sistem Qendror VRV Daikin & 24 Njësi Kasete',
      comment:
        'Për një hotel me 35 dhoma, qetësia e kondicionerëve dhe kontrolli i temperaturës janë vendimtare. Shërbimi pas shitjes dhe gatishmëria e inxhinierëve të DYRMA kanë qenë të jashtëzakonshme.',
      rating: 5,
      type: 'Biznes / Hotel',
    },
    {
      author: 'Besnik Murati',
      location: 'Apartament 110m², Qendër Elbasan',
      system: '2x Kondicioner Gree Fairy Inverter A+++',
      comment:
        'Instalim i pastër, pa asnjë pluhur dhe me pompë vakuumi siç duhet. Brenda 3 orësh gjithçka përfundoi dhe pajisjet funksionojnë pa asnjë zhurmë. Çmimi më konkurrues në treg!',
      rating: 5,
      type: 'Familjar',
    },
  ];

  return (
    <section className="py-16 px-4 sm:px-8 max-w-7xl mx-auto w-full">
      <div className="flex flex-col sm:flex-row justify-between sm:items-end gap-4 mb-10">
        <div>
          <div className="text-sky-600 dark:text-sky-400 font-extrabold text-xs uppercase tracking-wider mb-1">
            Vlerësimet e Klientëve
          </div>
          <h2 className="text-2xl sm:text-3xl font-black text-slate-900 dark:text-white">
            Besueshmëri e Dëshmuar në Çdo Projekt
          </h2>
        </div>
        <div className="flex items-center gap-1.5 text-xs text-slate-500 dark:text-slate-400">
          <div className="flex text-amber-400">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-4 h-4 fill-current" />
            ))}
          </div>
          <span className="font-bold text-slate-900 dark:text-white ml-1">4.9 / 5.0</span>
          <span>(mbi 850 instalime)</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {reviews.map((rev, idx) => (
          <div
            key={idx}
            className="bg-white dark:bg-slate-900 rounded-3xl border border-slate-200/80 dark:border-slate-800 p-6 flex flex-col justify-between hover:border-sky-300 dark:hover:border-sky-700 hover:shadow-lg transition-all"
          >
            <div className="space-y-4">
              <div className="flex justify-between items-start">
                <div className="flex text-amber-400">
                  {[...Array(rev.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-current" />
                  ))}
                </div>
                <span className="px-2 py-0.5 rounded-md bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400 text-[10px] font-bold">
                  {rev.type}
                </span>
              </div>

              <p className="text-xs sm:text-sm text-slate-700 dark:text-slate-300 leading-relaxed italic">
                &ldquo;{rev.comment}&rdquo;
              </p>
            </div>

            <div className="pt-4 mt-4 border-t border-slate-100 dark:border-slate-800">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-gradient-to-tr from-sky-600 to-blue-600 text-white font-bold text-xs flex items-center justify-center flex-shrink-0">
                  {rev.author.charAt(0)}
                </div>
                <div className="min-w-0">
                  <div className="font-bold text-xs text-slate-900 dark:text-white truncate flex items-center gap-1">
                    {rev.author}
                    <CheckCircle className="w-3.5 h-3.5 text-emerald-500 inline flex-shrink-0" />
                  </div>
                  <div className="text-[10px] text-slate-400 truncate">{rev.location}</div>
                </div>
              </div>
              <div className="text-[10px] text-sky-600 dark:text-sky-400 font-medium mt-2 truncate">
                Instaluar: {rev.system}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
